import { createSlice } from '@reduxjs/toolkit';

const boardSlice = createSlice({
  name: 'board',
  initialState: {
    isSuccess: false,
    isDeleteSuccess: false,
    isCategory: false,
    boardList: [],
    portletList: [],
    boardResult: {},
    topMenuInfo: {},
    portletResult: '',
    categoryId: null,
  },
  reducers: {
    deleteBoard: () => {},
    deleteBoardSuccess: state => {
      state.isDeleteSuccess = true;
    },
    deleteBoardFail: state => {
      state.isDeleteSuccess = false;
    },
    createBoard: state => {
      state.isSuccess = null;
    },
    createBoardSuccess: (state, { payload }) => {
      state.isSuccess = payload.data.success;
      state.boardResult = payload.data.result;
    },
    createBoardFail: state => {
      state.isSuccess = false;
    },
    getTopMenuList: () => {},
    getTopMenuListSuccess: (state, { payload }) => {
      state.topMenuInfo = payload.data.result.elements[0];
    },
    updateBoardList: (state, { payload }) => {
      const newData = {
        brdNm: state.boardResult.brdNm,
        enBrdNm: state.boardResult.enBrdNm,
        brdNo: state.boardResult.brdNo,
        portlet: payload.portlet, // y, n
        portletNo: state.portletResult,
      };
      if (payload.portlet === 'Y') {
        const _portletListArray = state.portletList;
        _portletListArray.push(state.portletResult);
        state.portletList = _portletListArray;
      }
      const _boardListArray = state.boardList;
      _boardListArray.push(newData);
      state.boardList = _boardListArray;
    },
    removeBoardList: (state, { payload }) => {
      const _boardListArray = state.boardList.filter(item => item.brdNo !== payload.brdNo);
      state.boardList = _boardListArray;
      if (payload.portlet === 'Y') {
        const _portletListArray = state.portletList.filter((value, idx) => value !== payload.portletNo);
        state.portletList = _portletListArray;
      }
    },
    addBoardList: () => {},
    addBoardListSuccess: (state, { payload }) => {
      state.addBoard = true;
    },
    addBoardListFail: (state, { payload }) => {
      state.addBoard = false;
    },
    createPortlet: state => {
      state.portletResult = '';
      state.isSuccess = false;
    },
    createPortletSuccess: (state, { payload }) => {
      state.isSuccess = payload.result;
      state.portletResult = payload.portlet.portletLabel;
    },
    createPortletFail: (state, { payload }) => {
      state.isSuccess = false;
    },
    createCategory: () => {},
    createCategorySuccess: (state, { payload }) => {
      state.isCategory = payload.result;
      state.categoryId = payload.category.categoryLabel;
    },
    createCategoryFail: (state, { payload }) => {
      state.isCategory = false;
    },
    arrangePortlet: () => {},
    arrangePortletSuccess: (state, { payload }) => {},
    arrangePortletFail: (state, { payload }) => {},
    deletePortlet: () => {},
    deletePortletSuccess: () => {},
    deletePortletFail: () => {},
  },
});

export const {
  createBoard,
  createBoardSuccess,
  createBoardFail,
  deleteBoard,
  deleteBoardSuccess,
  deleteBoardFail,
  getTopMenuList,
  getTopMenuListSuccess,
  updateBoardList,
  removeBoardList,
  addBoardList,
  addBoardListSuccess,
  addBoardListFail,
  createPortlet,
  createPortletSuccess,
  createPortletFail,
  createCategory,
  createCategorySuccess,
  createCategoryFail,
  arrangePortlet,
  arrangePortletSuccess,
  arrangePortletFail,
  deletePortlet,
  deletePortletSuccess,
  deletePortletFail,
} = boardSlice.actions;
export default boardSlice.reducer;
